import * as types from "./actionTypes.js";
import * as liveScheduleApi from '../../api/liveScheduleApi.js';

/**
 * Action that gets all the resources in a collection using the userId. Dispatches a successful action if successful. Throws an error if it cannot find a collection.
 * @param {*} resourceId
 */
export function fetchListOfResourceCollection(resourceId) {
  return function (dispatch) {
    return liveScheduleApi
      .getListOfResourceCollection(resourceId)
      .then(listResourceCollections => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_LIST_RESOURCE_COLLECTION_SUCCESS,
          listResourceCollections
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

/**
 * Returns a 1, 2, 7 or 9 day live schedule based on what option the user selects.
 * @param {*String} resourceId
 * @param {*} startDate
 * @param {*Int} scheduleFormat
 * @param {*String} resourceName
 */
export function fetchLiveSchedules(
  startDate,
  scheduleFormat,
  resourceType,
  resourceCollectionId,
  userId,
  resourceId,
  scheduleView
) {
  return function (dispatch) {
    return liveScheduleApi
      .getLiveSchedules(startDate,
        scheduleFormat,
        resourceType,
        resourceCollectionId,
        userId,
        resourceId,
        scheduleView
      )
      .then(liveSchedules => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_LIVE_SCHEDULES_SUCCESS,
          liveSchedules
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function updateEditModeStatus(payload) {
  return {
      type: types.UPDATE_EDIT_MODE_STATUS,
      payload
  };
}

export function updateOptimisticReRenderStatus(payload) {
  return {
      type: types.UPDATE_LIVE_SCHEDULE_OPTIMISTIC_RERENDER_STATUS,
      payload
  };
}

export function updateOptimisticSchedule(payload) {
  return {
      type: types.UPDATE_OPTIMISTIC_LIVE_SCHEDULE,
      payload
  };
}

export function deleteTourOptimistic(itemDetails) {
  return {
    type: types.LIVE_SCHEDULE_DELETE_TOUR_OPTIMISTIC,
    itemDetails
  };
}

export function addTourOptimistic(itemDetails, dayType, resourceId) {
  return {
    type: types.LIVE_SCHEDULE_ADD_TOUR_OPTIMISTIC,
    itemDetails,
    dayType,
    resourceId
  };
}

export function addDayTypeOptimistic(itemDetails, dayType, resourceId) {
  return {
    type: types.LIVE_SCHEDULE_ADD_DAY_TYPE_OPTIMISTIC,
    itemDetails,
    dayType,
    resourceId
  };
}

export function deleteDayTypeOptimistic(itemDetails) {
  return {
    type: types.LIVE_SCHEDULE_DELETE_DAY_TYPE_OPTIMISTIC,
    itemDetails
  };
}


export function editDayTypeOptimistic(itemDetails, updatedResource) {
  return {
    type: types.LIVE_SCHEDULE_EDIT_DAY_TYPE_OPTIMISTIC,
    itemDetails,
    updatedResource
  };
}

export function editTourOptimistic(itemDetails, updatedResource) {
  return {
    type: types.LIVE_SCHEDULE_EDIT_TOUR_OPTIMISTIC,
    itemDetails,
    updatedResource
  };
}

export function updateLiveScheduleParameters(parameters) {
  return function (dispatch) {
    dispatch({
      type: types.EDIT_LIVE_SCHEDULE_PARAMETERS_SUCCESS,
      parameters
    });
  }
}

